import { PawPrint } from "lucide-react";

const TIER_STYLES = {
  royalty: "bg-[#D4AF37] text-black",
  premium: "bg-[#8B5CF6] text-white",
};

export const BreedersTab = ({ breeders }) => (
  <div className="space-y-3">
    {breeders.length === 0 ? (
      <div className="glass-card p-8 text-center">
        <PawPrint className="w-12 h-12 text-[#3F3F46] mx-auto mb-3" />
        <p className="text-[#A1A1AA]">No breeders found</p>
      </div>
    ) : (
      breeders.map((breeder) => (
        <div key={breeder.breeder_id} className="glass-card p-4">
          <div className="flex items-start justify-between">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <h4 className="text-[#EDEDED] font-medium">
                  {breeder.business_name || "Unnamed Breeder"}
                </h4>
                <span
                  className={`px-2 py-0.5 text-xs rounded-full ${
                    TIER_STYLES[breeder.subscription_tier] || "bg-[#27272A] text-[#A1A1AA]"
                  }`}
                >
                  {breeder.subscription_tier || "free"}
                </span>
              </div>
              <p className="text-sm text-[#71717A]">
                {breeder.location_city}, {breeder.location_state}
              </p>
              <div className="flex gap-4 mt-2 text-sm text-[#A1A1AA]">
                <span>{breeder.user_email}</span>
                <span>{breeder.listing_count} listings</span>
                <span>Breeds: {breeder.breeds?.join(", ") || "Not specified"}</span>
              </div>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
);
